import { classNames } from "../utils/classNames";
import { IconName } from "./iconMapping";
import { Icon } from "./Icon";
import { TMessage } from "../i18n/tt";
import { when } from "../utils/functions";

import { useTranslation } from "../stores/RootStoreContext";
import { MouseEvent } from "react";

export type TagColor = "success" | "error" | "warning" | "neutral" | "info";

export type TagProps = {
  label: string | TMessage;
  color: TagColor;
  tooltip?: string | TMessage;
  icon?: IconName;
  compact?: boolean;
  isButton?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  className?: string;
};

export const Tag = ({
  label,
  color = "neutral",
  tooltip,
  icon,
  compact,
  isButton = false,
  onClick,
  className,
}: TagProps) => {
  const { t } = useTranslation();
  return (
    <div
      data-tooltip={typeof tooltip === "string" ? tooltip : when(tooltip, t)}
      className={classNames(
        className,
        "tw-inline-flex",
        "tw-flex-none",
        "tw-items-center",
        "tw-gap-1",
        isButton || onClick ? "tw-cursor-pointer" : "tw-cursor-default",
        "tw-w-fit",
        "tw-max-w-full",
        "tw-text-xs",
        "tw-py-1",
        "tw-rounded",
        compact ? "tw-px-1" : "tw-px-3",
        color === "info"
          ? "bg-info color-info"
          : color === "error"
            ? "bg-error color-error"
            : color === "warning"
              ? "bg-warning color-warning"
              : color === "success"
                ? "bg-success color-success"
                : "bg-gray-soft subtle",
        onClick && "hover:tw-underline",
      )}
      onClick={onClick}
    >
      {icon && <Icon name={icon} size={"sm"} />}
      <span className={"tw-overflow-hidden tw-overflow-ellipsis tw-whitespace-nowrap"}>
        {typeof label === "string" ? label : t(label)}
      </span>
    </div>
  );
};
